import React from 'react';

const books = [
  {
    id: 1,
    title: 'Shining at Full Efficacy: The Philosophy of Living Consciously',
    author: 'Vlad Russo',
    description: 'A philosophical exploration of conscious living — what it means to act with full presence, clarity, and intention in every dimension of life.',
    coverImage: '/resources/SFE.jpg',
    kindleUrl: 'https://www.amazon.com/dp/B0GYV3S8F7',
    publishedDate: '2026',
  },
  {
    id: 2,
    title: 'The Final Philosophy: An Irrefutable Proof',
    author: 'Vlad Russo',
    description: 'Something exists. You know this because you\'re something. You\'re reading these words. But what follows from that single, inarguable fact? This short but dense meditation on being takes the one thing no person can deny — "I think, therefore I am" — and follows reason, step by step, to its necessary conclusion. What follows this simple fact is profound realization on the nature of being. Each chapter makes a single claim and proves it. If you can agree at every step — which reason demands — then where we end up is something of the divine. What Descartes started, this book finishes.',
    coverImage: '/resources/final_phil.png',
    kindleUrl: 'https://www.amazon.com/dp/B0H12QW6SN',
    publishedDate: '2026',
  },
];

function BookCard({ book }) {
  return (
    <div className="book-card">
      <div className="book-cover">
        {book.coverImage
          ? <img src={book.coverImage} alt={book.title} />
          : <div className="book-cover-placeholder"><span>&#9781;</span></div>
        }
      </div>
      <div className="book-info">
        <p className="book-date">{book.publishedDate}</p>
        <h2 className="book-title">{book.title}</h2>
        <p className="book-author">{book.author}</p>
        <p className="book-description">{book.description}</p>
        <a
          className="book-cta"
          href={book.kindleUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Read on Kindle
        </a>
      </div>
    </div>
  );
}

function Books() {
  return (
    <div className="books-section">
      <p className="section-heading">Books</p>
      {books.map(book => <BookCard key={book.id} book={book} />)}
    </div>
  );
}

export default Books;
